import { render } from "./saleconsumptionreport.vue?vue&type=template&id=46c6f524&scoped=true"
import script from "./saleconsumptionreport.vue?vue&type=script&lang=js"
export * from "./saleconsumptionreport.vue?vue&type=script&lang=js"

import "./saleconsumptionreport.vue?vue&type=style&index=0&id=46c6f524&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c6f524"]])

export default __exports__